import React from 'react';
import { MedicalGroup, ModalProps } from '../../utils/types';
import { Dialog, DialogContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import CloseIcon from './CloseIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { TableCellStyles, TableHeaderCellStyles, StyledTableContainer, CellText } from './styles';

const filterMedicalGroups = (group: MedicalGroup): boolean => {
    return !!group.services[0].serviceStatus;
};

interface CountiesCheckProps {
    counties: string[];
    k: string;
}
const CountiesCheck = ({ counties, k }: CountiesCheckProps): JSX.Element => {
    return (
        counties.includes(k) ? <FontAwesomeIcon icon={faCheck} style={{ color: '#059669', width: '22px', height: '22px' }}/> : <FontAwesomeIcon icon={faTimes} style={{ color: '#DF6A24', width: '22px', height: '22px' }}/>
    );
};

interface Props extends ModalProps {
    groups: MedicalGroup[];
}

const MedicalGroupModal = ({ open, groups, handleClose }:Props): JSX.Element => {
    return (
        <Dialog
            maxWidth='lg'
            fullWidth={true}
            open={open}
            onClose={handleClose}
        >
            <DialogContent sx={{ padding: '30px' }}>
                <CloseIcon handleClose={handleClose}/>
                <StyledTableContainer>
                    <div style={{ marginBottom: '30px' }}>
                        <h1 style={{ textAlign: 'center', fontSize: '1.4rem' }}>Our Contracted Medical Groups</h1>
                    </div>
                    <div>
                        <TableContainer component={Paper} style={{ boxShadow: 'none' }}>
                            <Table>
                                <TableHead style={{ background: '#EBF9F6' }}>
                                    <TableCell align='left' style={TableHeaderCellStyles}><CellText>Medical Groups</CellText></TableCell>
                                    <TableCell align='center' style={TableHeaderCellStyles}><CellText>San Diego</CellText></TableCell>
                                    <TableCell align='center' style={TableHeaderCellStyles}><CellText>Orange County</CellText></TableCell>
                                </TableHead>
                                <TableBody style={{}}>
                                    {
                                        groups.filter(filterMedicalGroups).map((g, i) => {
                                            return (
                                                <TableRow key={i}>
                                                    <TableCell align='left' style={TableCellStyles}>
                                                        <CellText>{g.name}</CellText>
                                                    </TableCell>
                                                    <TableCell align='center' style={TableCellStyles}>
                                                        <CountiesCheck counties={g.counties} k='San Diego'/>
                                                    </TableCell>
                                                    <TableCell align='center' style={TableCellStyles}>
                                                        <CountiesCheck counties={g.counties} k='Orange County'/>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </StyledTableContainer>
            </DialogContent>
        </Dialog>
    );
};

export default MedicalGroupModal;
